module.exports = __webpack_public_path__ + "static/media/diaper191-259.da734515.png";